<template>
  <div>
    <v-list
      subheader
      two-line
      dense
    >
      <template v-for="(group, index) in allGroups">
        <group-list-item
          v-if="(canSeeArchived || !group.isArchived)"
          :key="`group_${index}`"
          :group="group"
        />
        <v-divider
          v-if="(index + 1 < allGroups.length) && (canSeeArchived || !group.isArchived)"
          :key="index"
        />
      </template>
    </v-list>

    <v-row
      justify="center"
      align="center"
    >
      <v-btn
        v-if="hasArchivedGroups && !canSeeArchived"
        class="my-5"
        color="primary"
        small
        text
        rounded
        outlined
        @click="showArchived"
      >
        <v-icon
          left
          small
        >
          remove_red_eye
        </v-icon>
        Show Archived Groups
      </v-btn>
    </v-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupListItem from '@/components/Group/GroupListItem.vue'

  export default {
    components: {
      GroupListItem
    },
    data(){
      return {
        canSeeArchived: false,
      }
    },
    methods: {
      showArchived(){
        this.canSeeArchived = true
      }
    },
    computed: {
      ...mapGetters([ 'allGroups' ]),
      hasArchivedGroups(){
        return this.allGroups.some(g => g.isArchived)
      },
    }
  }
</script>
